import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CardinfoDv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PortfolioTradeCard = _resolveComponent("PortfolioTradeCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PortfolioTradeCard, {
      trade: _ctx.trade[0],
      stockName: _ctx.stock.name,
      postUser: _ctx.postUser
    }, null, 8, ["trade", "stockName", "postUser"])
  ]))
}